import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import PasswordManagerDialog from "./components/PasswordManager/PasswordManagerDialog";
import { LicenseProvider } from "./contexts/LicenseContext";
import { I18nProvider } from "./contexts/I18nContext";
import { registerLicense } from "@syncfusion/ej2-base";

// Import Syncfusion CSS
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-buttons/styles/material.css";
import "@syncfusion/ej2-calendars/styles/material.css";
import "@syncfusion/ej2-dropdowns/styles/material.css";
import "@syncfusion/ej2-inputs/styles/material.css";
import "@syncfusion/ej2-navigations/styles/material.css";
import "@syncfusion/ej2-popups/styles/material.css";
import "@syncfusion/ej2-splitbuttons/styles/material.css";
import "@syncfusion/ej2-react-grids/styles/material.css";

if (process.env.REACT_APP_SYNCFUSION_LICENSE) {
  registerLicense(process.env.REACT_APP_SYNCFUSION_LICENSE);
}
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';

/* global Office */

// Check if we're in dialog mode
const isDialogMode = window.__DIALOG_MODE__ === true;

// Wait for Office to be ready before mounting React.
// This ensures the NAA broker is available when acquireOid() is called.
Office.onReady(() => {
  if (isDialogMode) {
    // Render Password Manager Dialog
    const dialogRoot = document.getElementById("dialog-root");
    if (dialogRoot) {
      const root = ReactDOM.createRoot(dialogRoot);
      root.render(
        <React.StrictMode>
          <I18nProvider>
            <LicenseProvider>
              <PasswordManagerDialog />
            </LicenseProvider>
          </I18nProvider>
        </React.StrictMode>
      );
    }
  } else {
    // Render Main App
    const appRoot = document.getElementById("root");
    if (appRoot) {
      const root = ReactDOM.createRoot(appRoot);
      root.render(
        <React.StrictMode>
          <I18nProvider>
            <App />
          </I18nProvider>
        </React.StrictMode>
      );
    }
  }
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
